import { render } from "./auto-reply-detail.vue?vue&type=template&id=3cba4550"
import script from "./auto-reply-detail.vue?vue&type=script&lang=js"
export * from "./auto-reply-detail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__